$(document).ready( function() {
	attachClickFunction();
});

// Verander het icoontje.
function saveItem(item) {
	var articleID = $(item).parents('.img-btns').parents('.btn_wrapper').siblings().attr('id').replace('item','');
	
	$(item).addClass("img-saved-btn");
	$(item).removeClass("img-save-btn");
	
	var xmlhttp = new XMLHttpRequest();
	xmlhttp.open('GET','/ajax/tagsajax?mode=s&id='+articleID+'&tag=Bewaard', true);
	xmlhttp.send();
	$(item).removeData('img-saved-initialized');
	attachClickFunction();
}

// Verander het icoontje.
function deleteItem(item) {
	var articleID = $(item).parents('.img-btns').parents('.btn_wrapper').siblings().attr('id').replace('item','');
	
	$(item).addClass("img-save-btn");
	$(item).removeClass("img-saved-btn");
	
	var xmlhttp = new XMLHttpRequest();
	xmlhttp.open('GET','/ajax/tagsajax?mode=d&id='+articleID+'&tag=Bewaard', true);
	xmlhttp.send();
	$(item).removeData('img-save-initialized');
	attachClickFunction();
}

// Zet click functie op ajax geladen items.
function attachClickFunction() {
	var saveItems = $(".img-save-btn").filter(function() {
		return !$(this).data('img-save-initialized');
	});
	
	var removeItems = $(".img-saved-btn").filter(function() {
		return !$(this).data('img-saved-initialized');
	});
	
	saveItems.click(function(event) {
		saveItem(this);
	});
	
	removeItems.click(function(event) {
		deleteItem(this);
	});
	
	saveItems.data('img-save-initialized',true);
	removeItems.data('img-saved-initialized',true);
}


// -----IDD-MINIFY-SETTINGS
// ecmaVersion:11
// -----IDD-MINIFY-SETTINGS-DONE
